const ordinals = {
  "XXS"          : 0,
  "2XS"          : 1,
  "XS"           : 2,
  "SS"           : 3,
  "S"            : 4,
  "ST"            : 4.3,
  "S/M"          : 4.5,
  "M"            : 5,
  "MS"           : 6,
  "ML"           : 7,
  "MT"            : 7.5,
  "L"            : 8,
  "LS"           : 9,
  "LL"           : 10,
  "LT"            : 10.3,
  "L/XL"         : 10.5,
  "XL"           : 11,
"XLT"           : 11.5,
  "XLS"          : 12,
  "XLL"          : 13,
  "XXL"          : 14,
  "2XL"          : 15,
"XXLT"          : 15.5,
  "XXXL"         : 16,
  "3XL"          : 17,
  "XXXXL"        : 18,
  "4XL"          : 19,
  "5XL"          : 20,
  "J (29.0-31.0)": 21,
  "A (32.0-33.5)": 22,
  "B (34.0-36.0)": 23,
  "C (37.0-38.5)": 24,
  "D (39.0-41.0)": 25,
  "E (42.0-44.0)": 26,
  "F (45.0-46.5)": 27,
  "G (47.0-49.0)": 28
}

export default ordinals



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/sortParamsVariant.js